import { AllProjectStatusLabels } from '@/utils/enum'

export interface ProjectStatusStyle {
  label: string
  /** Badge : fond + texte */
  pill: string
  /** Pastille de couleur dans le badge */
  dot: string
}

const GREEN = { pill: 'bg-[#E7F6EE] text-[#0B6B3A]', dot: 'bg-[#16A34A]' }
const BLUE = { pill: 'bg-[#E8F0FE] text-[#1D4ED8]', dot: 'bg-[#2563EB]' }
const CYAN = { pill: 'bg-brand-light text-brand-dark', dot: 'bg-brand-bright' }
const RED = { pill: 'bg-red-50 text-red-700', dot: 'bg-red-500' }
const GRAY = { pill: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' }

// Statuts « en service » en vert : un projet en maintenance tourne, ce n'est pas une alerte.
const STATUS_COLORS: Record<string, typeof GREEN> = {
  pre_development: CYAN,
  planning: CYAN,
  in_development: BLUE,
  in_progress: BLUE,
  maintenance: GREEN,
  on_hold: GREEN,
  delivered: GREEN,
  completed: GREEN,
  cancelled: RED,
  draft: GRAY,
}

export function getProjectStatusStyle(status: string): ProjectStatusStyle {
  const key = (status || '').toLowerCase()
  const colors = STATUS_COLORS[key] ?? GRAY
  return { label: AllProjectStatusLabels[key] || status, ...colors }
}
